import { useParams } from 'react-router-dom';
import RecoverPassword from '@/containers/RecoverPassword';
import { BasicLayout } from '@/layouts/BasicLayout';

const RecoverPasswordPage = () => {
  const { key } = useParams();
  return (
    <BasicLayout>
      <div className="container">
        <RecoverPassword token={key} />
      </div>
    </BasicLayout>
  );
};

export default RecoverPasswordPage;
